import request from '../request.js'

// 获取组织架构
const getSysDept = function (data) {
    return request({
        url: 'sysDept/selectDeptTree',
        method: 'post',
        data
    })
}

// 新增组织架构
const insertSysDept = function (data) {
    return request({
        url: 'sysDept/insert',
        method: 'post',
        data
    })
}

// 删除组织架构
const  deleteSysDept = function (data) {
    return request({
        url: 'sysDept/deleteById',
        method: 'post',
        data
    })
}

// 获取组织架构信息
const  getDeptInfo = function (data) {
    return request({
        url: 'sysDept/selectById',
        method: 'post',
        data
    })
}

// 获取用户组所属组织
const  getGroupDepts = function (data) {
    return request({
        url: 'sysDept/selectGroupDepts',
        method: 'post',
        data
    })
}

const getPageList = function (data) {
    return request({
        url: 'sysExceptionInfo/getPageList',
        method: 'post',
        data
    })
}

const getLogPageList = function (data) {
    return request({
        url: 'sysLog/getPageList',
        method: 'post',
        data
    })
}

//zwh-接口信息
const getAddCheckInterfaceList = function (data) {  //获取所有接口信息,已根据菜单id，过了已添加的接口信息
    return request({
        url: 'sysInterface/getAddCheckInterfaceList',
        method: 'post',
        data
    })
}

//zwh-菜单接口信息
const getMenuInterfaceList = function (data) {  //菜单接口列表信息（不分页）
    return request({
        url: 'sysInterface/getMenuInterfaceList',
        method: 'post',
        data
    })
}

//根据文件id预览文件
const previewFile = function (data) {
    return request({
        url: 'sysFile/previewFile',
        method: 'post',
        data
    })
}

export {
    getSysDept,
    getDeptInfo,
    getPageList,
    previewFile,
    deleteSysDept,
    insertSysDept,
    getGroupDepts,
    getLogPageList,
    getMenuInterfaceList,
    getAddCheckInterfaceList
}